<template>
  <div class="modal-wrapper">

    <div class="overlay" @click="$parent.close !== undefined ? $parent.close() : () => {}"></div>

    <div class="shape-wrapper">

      <div class="shape" :style="shapeSize">

        <div class="modal-wrapper">

          <slot></slot>

          <div class="button-wrapper">

            <!--<layout-text-button v-if="!disableCancelButton" class="button" text="취소" :callback="close"/>-->

            <!--<layout-text-button class="button" text="확인" :callback="submit" :class="{ 'disabled': disabled}"/>-->

            <div class="modal-text-button-style">
              <LayoutTextButton title="취소" class="button" :is-type="2" :callback="close"/>
              <LayoutTextButton title="확인" class="button" :is-type="2" :callback="submit"/>
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import LayoutTextButton from '../LayoutButtonText';

export default {
  name: 'ModalFrame',
  props: {
    shapeWidth: {
      type: Number,
      default: 500,
    },
    shapeHeight: {
      type: Number,
      default: 300,
    },
    submit: Function,
    disabled: {
      type: Function,
      default: null,
    },
    disableCancelButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: this.$parent.$options.name,
      compareValue: '',
    };
  },
  methods: {
    isArrayType(value) {
      return Array.isArray(value);
    },

    close() {
      this.$modal.clearComponent();
    },
  },
  computed: {
    shapeSize() {
      return { width: `${this.shapeWidth}px`, height: `${this.shapeHeight}px` };
    },
  },
  components: {
    LayoutTextButton,
  },
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  position: fixed;

  display: flex;
  flex-direction: column;

  z-index: 1005;

  top: 0;
  right: 0;
  left: 0;
  bottom: 0;

  margin: 0 auto;

  width: 100%;
  height: 100%;

  .overlay {
    position: fixed;
    width: 120vw;
    height: 120vh;
    top: -20vh;
    left: -20vw;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1000;
  }

  .shape-wrapper {
    position: relative;

    width: 100vw;
    height: 100vh;

    .shape {
      position: absolute;
      z-index: 1006;

      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      background: rgb(255, 255, 255);
    }
  }
}

.button-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
  padding-right: 24px;

  width: auto;

  .modal-text-button-style {
    position: relative;
    width: auto;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    box-sizing: border-box;

    .button {
      width: 120px;
      height: 48px;
      margin: 0 8px;
      border-radius: 4px;
      transition: all 0.3s;
      &:hover {
        filter: brightness(1.1);
      }

      animation: none;
    }
    .button:first-child {
      background: #ff4e62;
    }

    .button:last-child {
      background: #008FF8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/modal/ModalFrame.vue